import LoseUserRegister from './LoseUserRegister';

export default LoseUserRegister;
